import React, {FC, PropsWithChildren} from 'react';

import {
  InterfaceEventsEnum,
  trackInterfaceEvent,
} from '../../../../libs/shared/core/src/services/tracking/tracking';
import {
  LinkTrackingContext,
  LinkTrackingContextProps,
} from '../../../../libs/shared/ui/src/components/links/linkTrackingContext';

function trackLinkTrapHref(href: string) {
  if (href.startsWith('https://www.google.com/calendar/event?action=RESPOND')) {
    trackInterfaceEvent(InterfaceEventsEnum.CLICK_GCAL_RSVP_LINK);
  }
}

const contextValue: LinkTrackingContextProps = {
  trackLinkTrapHref,
};

export const LinkTrackingProvider: FC<PropsWithChildren> = ({children}) => (
  <LinkTrackingContext.Provider value={contextValue}>{children}</LinkTrackingContext.Provider>
);
